import {ATTENDANCE_STATUS} from '../../../CodeMaster'

export default class BaseMeetingAttendanceResponse {
    attendanceStatus: ATTENDANCE_STATUS

    constructor(attendanceStatus: ATTENDANCE_STATUS) {
        this.attendanceStatus = attendanceStatus
    }
}
